export enum ViewGroupSavedViewsBlock {
  Root = 'ViewGridToolbarGroupSavedViews',
}

export enum ViewGroupSavedViewsElement {
  Filter = 'filter',
}
